import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ConnectivityCatalogEntry, ConnectivityCatalogType } from 'src/app/domains/connectivity/models/connectivity.model';
import { ConnectivityService } from 'src/app/domains/connectivity/services/connectivity.service';
import { Paginated } from 'src/app/shared/paginated.model';

@Component({
  selector: 'gdp-connectivity-entry-search',
  templateUrl: './connectivity-entry-search.component.html',
  styleUrls: ['./connectivity-entry-search.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ConnectivityEntrySearchComponent),
      multi: true
    }
  ]
})
export class ConnectivityEntrySearchComponent implements OnInit, ControlValueAccessor {

  @Input() type: ConnectivityCatalogType = null;

  public currentSelected: ConnectivityCatalogEntry;

  public fullCatalogList: ConnectivityCatalogEntry[] = [];
  public filteredCatalogList: ConnectivityCatalogEntry[] = [];

  public searchTerm: string = "";
  public isLoading: boolean = false;

  public onChange = null;
  public onTouch = null;
  public disabled: boolean = false;

  constructor(
    private connectivityService: ConnectivityService
  ) { }

  ngOnInit(): void {
    const filters = {
      type: this.type,
      page: 0,
      size: 1000
    };
    !filters.type && delete filters.type;
    this.isLoading = true;
    this.connectivityService.getDevices(filters).subscribe((response: Paginated<ConnectivityCatalogEntry>) => {
      this.fullCatalogList = this.filteredCatalogList = response.content;
      if (this.currentSelected) {
        //in case write value setted a value we need to confirm it's valid
        if (!this.fullCatalogList.find((el: ConnectivityCatalogEntry) => el.id === this.currentSelected.id)) {
          this.currentSelected = null;
        }
      }
      this.isLoading = false;
    }, () => {
      this.isLoading = false;
    });
  }

  public onFilterEntries() {
    if (this.searchTerm.length < 2) {
      this.filteredCatalogList = this.fullCatalogList;
    }
    this.filteredCatalogList = this.fullCatalogList.filter((ele: ConnectivityCatalogEntry) => {
      return `${ele.brand} - ${ele.model}`.toLowerCase().includes(this.searchTerm.toLowerCase());
    })
  }

  public onSelectEntry(entry: ConnectivityCatalogEntry) {
    if (entry) {
      this.currentSelected = entry;
      this.onChange(entry);
    }
  }

  public onKeypress(evt: any) {
    if (evt.key === 'Enter') {
      this.currentSelected = this.filteredCatalogList[0];
    }
  }

  writeValue(obj: ConnectivityCatalogEntry): void {
    if (obj) {
      if (!this.fullCatalogList.length) {
        this.currentSelected = obj;
        // if on change is registered before write value is executed
        if (this.onChange) this.onChange(this.currentSelected);
      } else {
        this.currentSelected = this.fullCatalogList.find((el: ConnectivityCatalogEntry) => el.id === obj.id);
        if (this.onChange) this.onChange(this.currentSelected);
      }
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
    if (this.currentSelected) this.onChange(this.currentSelected);
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

}
